import i18n from 'i18next';

// Import variables
import { LANGUAGES_TYPES } from 'helpers/variables';

const { PL } = LANGUAGES_TYPES;

export const getNewPath = ({ pathname, newLng }) => {
	const { language } = i18n;
	const isPlLng = language === PL;
	const coreLngPath = isPlLng ? newLng : PL;

	return `/${coreLngPath}${pathname}`;
};
